import config from '@_src/common/core/config';
import menu from '@_src/common/core/config/menu';

export default {
  methods: {
    handleLogin () {
      window.location.href = menu.manage.url;
    },
    handleLogout () {
      localStorage.removeItem(config.lsSidName);
      localStorage.removeItem(config.lsUser);
      window.location.href = config.logout;
    },
  },
};
